// extracted by mini-css-extract-plugin
module.exports = {"green":"#79c80e","warning":"#d5e100","darkBlue":"#008dcd","info":"#00d0eb","dark":"#333","light":"#f2f2f2","white":"#fff","black":"#000"};